import React from 'react'
import PropTypes from 'prop-types'

function Input({ label, value, onChange, disabled, className, endDropDownList, type = "number", placeholder, errorMessage, inputClassName, onBlur }) {
   
    return (
        <div className={className}>
            <label htmlFor="goldRate" className="form-label">
                {label} {errorMessage &&<span style={{color:"red"}}>*</span>}
            </label>
            <div className="input-group">
                <input
                    type={type}
                    className={`form-control  ${errorMessage ? 'is-invalid validation_error_background' : ''} ${inputClassName}`}
                    aria-label="Text input with dropdown button"
                    value={value}
                    autoComplete={"new-password"}
                    // defaultValue={defaultValue}
                    onChange={onChange}
                    disabled={disabled}
                    placeholder={placeholder}
                    onBlur={onBlur}
                />
                {endDropDownList &&
                    <DropDown endDropDownList={endDropDownList} disabled={disabled} />
                }
            </div>
            {errorMessage && <div className='validation_error pl-1'>{errorMessage}</div>}
        </div>
    )
}
const DropDown = ({ endDropDownList, disabled }) => {
    const {
        activeValue,
        dropDownOnChange,
        dropDownList
    } = endDropDownList
    return <div className="input-group-append">
        <button
            className="btn goldBtn btn-outline-secondary dropdown-toggle btn-sm"
            type="button"
            data-toggle="dropdown"
            aria-expanded="false"
            disabled={disabled}
        >
            {activeValue}
        </button>
        <div className="dropdown-menu">
            {dropDownList.map((state, index) => (
                <a
                    className={`dropdown-item ${activeValue === state.value && 'active'}`}
                    href="/"
                    key={index}
                    onClick={(event) => {
                        event.preventDefault(); // Prevent the default link behavior
                        dropDownOnChange(state.value);
                    }}
                >
                    {state.label}
                </a>
            ))}
        </div>
    </div>
}
Input.propTypes = {
    label: PropTypes.string,
    endDropDownList: PropTypes.object,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.any,
    type: PropTypes.string
}

export default Input